import { render, staticRenderFns } from "./COptinsPanel.vue?vue&type=template&id=63a023bd&"
import script from "./COptinsPanel.vue?vue&type=script&lang=js&"
export * from "./COptinsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports